var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "saas-page linear-admin-workflow" },
    [
      _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
        _c("div", { staticClass: "saas-hero__main" }, [
          _c(
            "p",
            { staticClass: "saas-hero__crumb" },
            [
              _c("router-link", { attrs: { to: "/home" } }, [
                _vm._v(_vm._s(_vm.trans("general.home"))),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.trans("template.template")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "linear-eyebrow" }, [
            _vm._v(_vm._s(_vm.trans("template.template"))),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "saas-hero__title" }, [
            _vm._v(_vm._s(_vm.trans("template.template"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.email_templates.total
          ? _c("div", { staticClass: "linear-command-actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showCreatePanel = !_vm.showCreatePanel
                    },
                  },
                },
                [
                  _c("admin-icon", { attrs: { name: "plus" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.trans("template.add_new_template")) +
                      "\n            "
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showCreatePanel
          ? _c("div", { staticClass: "card-saas linear-admin-panel" }, [
              _c("div", { staticClass: "linear-section-head" }, [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.trans("template.template")))]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(_vm._s(_vm.trans("template.add_new_template"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "linear-admin-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      return _vm.templateForm.errors.clear($event.target.name)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(_vm._s(_vm.trans("template.name"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.templateForm.name,
                                expression: "templateForm.name",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              value: "",
                              name: "name",
                              placeholder: _vm.trans("template.name"),
                            },
                            domProps: { value: _vm.templateForm.name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.templateForm,
                                  "name",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.templateForm,
                              "prop-name": "name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(_vm._s(_vm.trans("template.category"))),
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "name",
                              name: "category",
                              id: "category",
                              options: _vm.categories,
                              placeholder: _vm.trans(
                                "template.select_category"
                              ),
                            },
                            on: {
                              select: _vm.onCategorySelect,
                              close: function ($event) {
                                return _vm.templateForm.errors.clear("category")
                              },
                              remove: function ($event) {
                                _vm.templateForm.category = ""
                              },
                            },
                            model: {
                              value: _vm.selected_category,
                              callback: function ($$v) {
                                _vm.selected_category = $$v
                              },
                              expression: "selected_category",
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.templateForm,
                              "prop-name": "category",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-wrap gap-2 justify-content-end",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm admin-form-btn-cancel",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.showCreatePanel = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.trans("general.save")))]
                      ),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.email_templates.total
        ? _c(
            "div",
            { staticClass: "admin-list-table-card linear-table-card mt-3" },
            [
              _c(
                "div",
                {
                  staticClass: "linear-section-head linear-section-head--table",
                },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.trans("template.template"))),
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v(_vm._s(_vm.trans("template.template")))]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table admin-data-table linear-dense-table mb-0",
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.trans("template.name")))]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("template.category"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.trans("template.subject"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "admin-table-actions-cell" }, [
                          _vm._v(_vm._s(_vm.trans("general.actions"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.email_templates.data,
                        function (email_template) {
                          return _c("tr", { key: email_template.id }, [
                            _c("td", [
                              _c("span", {
                                staticClass: "linear-table-primary",
                                domProps: {
                                  textContent: _vm._s(email_template.name),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", {
                                staticClass: "linear-pill",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.toWord(email_template.category)
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", {
                                staticClass:
                                  "linear-table-muted linear-table-truncate",
                                domProps: {
                                  textContent: _vm._s(email_template.subject),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "admin-table-actions-cell" },
                              [
                                _c(
                                  "table-row-action-dropdown",
                                  [
                                    _c(
                                      "b-dropdown-item-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.editEmailTemplate(
                                              email_template
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: { name: "pencil" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.trans(
                                                "template.edit_template"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !email_template.is_default
                                      ? _c(
                                          "b-dropdown-item-button",
                                          {
                                            directives: [
                                              {
                                                name: "confirm",
                                                rawName: "v-confirm",
                                                value: {
                                                  ok: _vm.confirmDelete(
                                                    email_template
                                                  ),
                                                },
                                                expression:
                                                  "{ok: confirmDelete(email_template)}",
                                              },
                                            ],
                                            staticClass:
                                              "admin-row-actions__danger",
                                          },
                                          [
                                            _c("admin-icon", {
                                              attrs: { name: "trash" },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.trans(
                                                    "template.delete_template"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "admin-table-pagination-wrap" },
                [
                  _c("pagination-record", {
                    attrs: {
                      "page-length": _vm.filterEmailTemplateForm.page_length,
                      records: _vm.email_templates,
                    },
                    on: {
                      "update:pageLength": function ($event) {
                        return _vm.$set(
                          _vm.filterEmailTemplateForm,
                          "page_length",
                          $event
                        )
                      },
                      "update:page-length": function ($event) {
                        return _vm.$set(
                          _vm.filterEmailTemplateForm,
                          "page_length",
                          $event
                        )
                      },
                      updateRecords: _vm.getEmailTemplates,
                    },
                    nativeOn: {
                      change: function ($event) {
                        return _vm.getEmailTemplates.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.email_templates.total
        ? _c(
            "div",
            {
              staticClass:
                "admin-list-table-card admin-empty-state linear-empty-state mt-3",
              attrs: { role: "status" },
            },
            [
              _c("div", { staticClass: "admin-empty-state__inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "admin-empty-state__icon-wrap",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("admin-icon", { attrs: { name: "mail" } })],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "admin-empty-state__title" }, [
                  _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-empty-state__text" }, [
                  _vm._v(_vm._s(_vm.trans("template.template"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3" }, [
                  !_vm.showCreatePanel
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          on: {
                            click: function ($event) {
                              _vm.showCreatePanel = !_vm.showCreatePanel
                            },
                          },
                        },
                        [
                          _c("admin-icon", { attrs: { name: "plus" } }),
                          _vm._v(" " + _vm._s(_vm.trans("general.add_new"))),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }